module.exports = __webpack_public_path__ + "img/help8.cfb3d51e.png";